
import React from "react";
import { Page } from "../../types/page";
import PageEditorForm from "./editors/page-editor/PageEditorForm";
import { usePageEditor } from "./editors/page-editor/usePageEditor";

interface PageEditorProps {
  page: Page;
  onSave: (page: Page) => void;
  onCancel: () => void;
}

const PageEditor: React.FC<PageEditorProps> = ({ page, onSave, onCancel }) => {
  const {
    editedPage,
    handleTitleChange,
    handleContentChange,
    handlePlatformChange,
    handlePositionChange,
    handleRotationTimeChange,
    handleRotationTimeInputChange,
    handleUseCustomRotationTimeChange,
    handleSavePage
  } = usePageEditor({ page, onSave });

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-frank">
        {editedPage.id ? "עריכת דף" : "יצירת דף חדש"}
      </h2>
      
      <PageEditorForm
        editedPage={editedPage}
        handleTitleChange={handleTitleChange}
        handleContentChange={handleContentChange}
        handlePlatformChange={handlePlatformChange}
        handlePositionChange={handlePositionChange}
        handleRotationTimeChange={handleRotationTimeChange}
        handleRotationTimeInputChange={handleRotationTimeInputChange}
        handleUseCustomRotationTimeChange={handleUseCustomRotationTimeChange}
        handleSavePage={handleSavePage}
        onCancel={onCancel}
      />
    </div>
  );
};

export default PageEditor;
